import React from 'react'
import PropTypes from 'prop-types'
import './_pageContainer.scss'
const PageContainer = ({children, background = 'var(--color-background-layer-01)', borderRadius = '8px', height = '100%',minHeight, className = ''}) => {
  return (
    <div className={'pc-container-position flex flex-col text-base'}>
      <div
        style={{
          '--dynamic-background': background,
          '--dynamic-border-radius': borderRadius,
          '--dynamic-height': height,
          '--dynamic-min-height': minHeight,
        }}
        className={`shadow pc-block mb-3 mt-4 flex w-full flex-col  p-6 text-white ${className}`}
        data-cy="page-content"
      >
        {children}
      </div>
    </div>
  )
}

PageContainer.propTypes = {
  children: PropTypes.node.isRequired,
  background: PropTypes.string,
  borderRadius: PropTypes.string,
  height: PropTypes.string,
  minHeight: PropTypes.string,
  className: PropTypes.string,
}

export default React.memo(PageContainer)
